export default __webpack_public_path__ + "static/media/img_major05_2.ac9bebc7.jpg";